import { render } from "./farmerDetail.vue?vue&type=template&id=77bbbf9a&scoped=true&ts=true"
import script from "./farmerDetail.vue?vue&type=script&lang=ts"
export * from "./farmerDetail.vue?vue&type=script&lang=ts"

import "./farmerDetail.vue?vue&type=style&index=0&id=77bbbf9a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bbbf9a"]])

export default __exports__